import React from 'react';
import { InfoIcon } from 'components/common/icons';
import { BaseAlert } from './baseAlert';
import { alertClasses, alertTypes } from '../constants';

export const InfoAlert = props => (
  <BaseAlert
    {...props}
    icon={InfoIcon}
    className={alertClasses[alertTypes.INFO]}
  />
);

export default InfoAlert;
